import styled from 'styled-components';

export const Wrapper = styled.div`
margin: 50px;
display: flex;
align-items: center;
flex-direction: column;
  span {
    display: inline-block;
    width: 70px;
  }
  button {
    appearance:none;
    box-sizing:border-box;
    width: 100px;
    height: 36px;
    line-height:20px;
    border-radius:2px;
    padding:8px 0;
    background-color:#4ba3bb;
    margin:2px;
    color:#fff;
    border:none;
    font-size: 15px;
    cursor: pointer;
    outline: none;
    &.clicked {
      background-color: #4ba3bb;
      color: #fff;
      border: 1px solid #4ba3bb;
    }
    &.notclicked {
      background-color: #fff;
      color: #4ba3bb;
      border: 1px solid #4ba3bb;
    }
  }
  td, th {
    border: 1px solid #ddd;
    padding: 8px;
  }

  td {
    white-space: pre-wrap;
  }

  tr:nth-child(even){background-color: #f2f2f2;}
  tr:hover {background-color: #ddd;}
  th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #4ba3bb;
    color: white;
}
`;
